var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.695 81.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.992-65.23,18.883-67.1a3.357,3.357,0,0,1-1.685-.789,2.907,2.907,0,0,1-.022-4.311l2.982-2.971a2.9,2.9,0,0,1,4.3.011,2.9,2.9,0,0,1,.022,4.311l-.67.67a4.632,4.632,0,0,1,.238,3.155l2.215-2.182a5.255,5.255,0,0,0-.011-7.735,5.255,5.255,0,0,0-7.735-.011L15.4-73.84a5.255,5.255,0,0,0,.011,7.735A3.829,3.829,0,0,0,16.992-65.23Zm2.766-7.714-1.88,1.869a3.4,3.4,0,0,1,1.685.789,2.916,2.916,0,0,1,.022,4.311L16.6-63a2.907,2.907,0,0,1-4.311-.011,2.907,2.907,0,0,1-.022-4.311l.681-.67a4.509,4.509,0,0,1-.238-3.155L10.5-68.968a5.255,5.255,0,0,0,.011,7.735,5.255,5.255,0,0,0,7.735.011l3.111-3.111a5.255,5.255,0,0,0-.011-7.735A3.874,3.874,0,0,0,19.758-72.944Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.327e706b40d71a954596c7a9a0f2953f.svg";
export { ForwardRef as ReactComponent };